var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSofts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_5318284",
    enableBackground: "new 0 0 512 512",
    height: 20,
    viewBox: "0 0 512 512",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456 112c-20.197 0-144.69 0-160 0v-52c0-11.028 8.972-20 20-20h60v-40h-60c-33.084 0-60 26.916-60 60v52c-7.885 0-196.645 0-200 0v40h42.099l34.069 306.626c3.382 30.428 29.019 53.374 59.634 53.374h128.396c30.615 0 56.252-22.946 59.634-53.374l34.069-306.626h42.099zm-308.698 120.606c45.567 3.194 70.15 18.702 98.018 36.303 27.566 17.41 58.396 36.862 110.694 41.859l-8.735 78.612c-35.192-5.628-57.35-19.607-80.599-34.291-27.492-17.364-58.305-36.817-110.419-41.845zm172.896 239.394h-128.396c-10.205 0-18.75-7.648-19.877-17.791l-11.13-100.171c37.541 5.206 60.477 19.683 84.526 34.872 25.092 15.848 53.108 33.533 97.537 40.264l-2.782 25.035c-1.127 10.143-9.673 17.791-19.878 17.791zm40.23-200.96c-42.901-3.852-66.703-18.868-93.748-35.949-29.855-18.856-63.348-39.998-123.855-42.773l-4.48-40.318h235.309z",
    fill: "#8BA4BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofts);
export default __webpack_public_path__ + "static/media/Softs.87d4bf81a43b4fa5e3d9c2c33a2706ad.svg";
export { ForwardRef as ReactComponent };